/**
 * #276 -- copy and formatting for the revenue-slab fields. The field types
 * live on `CommissionSlabRecord` in `types/index.ts`.
 */
import type { CommissionSlabRecord, SlabBasis } from '../../types';

/**
 * Spelled out rather than title-cased from the code, because the difference
 * between the two is the whole of #276: one ADDS a bonus on top of the grid
 * commission, the other REPLACES the grid rate for the policies that reach the
 * tier. A broker choosing between them from a label reading "Rate of net
 * premium" would have no way to know the second overrides their grid.
 */
export const SLAB_BASIS_LABELS: Record<SlabBasis, string> = {
  bonus_on_commission: 'Bonus % added to the grid commission',
  rate_of_net_premium: 'Tier rate % of net premium (replaces the grid rate)',
};

/** The criteria a slab narrows on, as one readable cell. Empty = no gate. */
export function slabCriteriaSummary(slab: CommissionSlabRecord): string {
  const parts: string[] = [];
  if (slab.product_name) parts.push(slab.product_name);
  if (slab.vehicle_condition === 'new') parts.push('New vehicles');
  if (slab.vehicle_condition === 'old') parts.push('Rollover vehicles');
  if (slab.ncb_applicable === true) parts.push('With NCB');
  if (slab.ncb_applicable === false) parts.push('Without NCB');
  return parts.join(' · ');
}
